import {
    getMethod,
    deleteMethod
} from "../../api-service/api-service";

import {
    setLeads,
    setSelectedLead,
    removeLead
} from "./leadSlice";

/* GET ALL */
export const fetchLeads = (filters = {}) => async (dispatch) => {
    try {
        const query = new URLSearchParams(filters).toString();
        const res = await getMethod(`/lead?${query}`);

        if (res?.success) {
            dispatch(setLeads(res.leads));
        }

        return res;
    } catch (err) {
        console.log(err);
        return { success: false };
    }
};

/* GET DETAILS */
export const fetchLeadDetails = (id) => async (dispatch) => {
    const res = await getMethod(`/lead/${id}`);
    if (res?.success) dispatch(setSelectedLead(res.lead));
    return res;
};

/* DELETE */
export const deleteLead = (id) => async (dispatch) => {
    const res = await deleteMethod(`/lead/${id}`);
    if (res?.success) dispatch(removeLead(id));
    return res;
};